// extracted by mini-css-extract-plugin
export var animatedlink = "r_bl";